import {
    LABEL_WIDTH,
    TIME_BLOCK_HEIGHT,
    TOTAL_BLOCKS,
    UNSCHEDULED_BLOCK_HEIGHT,
} from '@/common/utils/timeBlockUtils';
import { createStyles } from '@mantine/styles';

export const useStyles = createStyles(theme => ({
    plannerArea: {
        position: 'relative',
        height: TIME_BLOCK_HEIGHT * TOTAL_BLOCKS,
        borderLeft: `1px solid ${theme.colors.gray[3]}`,
        marginLeft: 60,
    },
    timeGridLayer: {
        position: 'relative',
        zIndex: 1,
    },

    dropAreaLayer: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 5,
        pointerEvents: 'none', // 기본적으로 클릭 이벤트 무시
    },
    dropHighlight: {
        background: theme.colors.blue[1],
        pointerEvents: 'auto', // 드롭 가능 영역만 클릭 이벤트 활성화
        zIndex: 10,
    },
    timeGridCell: {
        height: TIME_BLOCK_HEIGHT,
        position: 'relative',
    },
    // hour mark가 있을 경우 border를 함께 표시
    timeGridCellWithHourMark: {
        height: TIME_BLOCK_HEIGHT,
        borderTop: `1px solid ${theme.colors.gray[2]}`,
        position: 'relative',
    },
    // 제일 첫번째는 위에 border가 있어 투명하게
    timeGridCellWithHourMarkFirst: {
        height: TIME_BLOCK_HEIGHT,
        borderTop: `1px solid transparent`,
        position: 'relative',
    },
    // 시간 레이블 영역 중 시간을 표시하는 부분
    hourMark: {
        zIndex: 3,
        position: 'absolute',
        left: -60,
        width: LABEL_WIDTH,
        top: -9,
        textAlign: 'center',
        fontSize: theme.fontSizes.xs,
        color: theme.colors.gray[6],
    },
    // 시간 레이블 영역 중 00시를 표시하는 부분 - 텍스트 보이게 여백 설정하기 위해 클래스 따로 사용
    hourMarkFirst: {
        zIndex: 3,
        position: 'absolute',
        left: -60,
        width: LABEL_WIDTH,
        top: -4,
        textAlign: 'center',
        fontSize: theme.fontSizes.xs,
        color: theme.colors.gray[6],
        transform: 'translateY(20%)', // 아래쪽으로 절반 이동하여 컨테이너 내부에 표시
    },
    // 시각 텍스트를 표시하지 않는 시간 레이블 영역 - 클릭 이벤트 처리를 위해 요소 생성
    hourMarkBox: {
        zIndex: 3,
        position: 'absolute',
        left: -60,
        width: LABEL_WIDTH,
        height: TIME_BLOCK_HEIGHT,
        top: -9,
        textAlign: 'center',
        fontSize: theme.fontSizes.xs,
        color: theme.colors.gray[6],
    },
    unscheduledLabel: {
        width: LABEL_WIDTH,
        height: UNSCHEDULED_BLOCK_HEIGHT, // 한칸이 보이는 적정 높이 지정
        textAlign: 'center',
        fontSize: theme.fontSizes.xs,
        color: theme.colors.gray[6],
    },
    dragArea: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
    dragPreview: {
        position: 'absolute',
        left: 0,
        right: 0,
        pointerEvents: 'none',
    },
    plannerBlock: {
        position: 'absolute',
        left: 4,
        right: 4,
        // borderRadius: theme.radius.sm,
        // fontSize: theme.fontSizes.xs,
        // overflow: 'hidden',
        cursor: 'pointer',
        // transition: 'background-color 0.2s',

        // '&:hover': {
        //     filter: 'brightness(0.95)',
        // },
    },
    plannerArticle: {
        borderRadius: theme.radius.sm,
        borderStyle: 'solid',
        borderWidth: 2,
        maxWidth: '100%',
        overflow: 'hidden',
        fontSize: theme.fontSizes.xs,
        fontWeight: 400,
        whiteSpace: 'nowrap',
        height: '100%',
        transition: 'background-color 0.2s',

        '&:hover': {
            // filter: 'brightness(0.96)',
            boxShadow: `0 2px 4px ${theme.fn.rgba(theme.colors.dark[3], 0.2)}`,
            transform: 'translateY(-1px)',
        },
    },

    plannerContent: {
        borderRadius: theme.radius.sm,
        borderColor: 'transparent',
        borderStyle: 'solid',
        borderWidth: 1,
        display: 'flex',
        width: '100%',
        height: '100%',
        alignItems: 'stretch',
        gap: 20,
        overflow: 'hidden',
        justifyContent: 'space-between',
    },

    plannerTitleWrapper: {
        display: 'flex',
        alignItems: 'stretch',
        gap: 9,
        color: theme.black,
        lineHeight: 1,
    },

    plannerColorBar: {
        display: 'flex',
        width: 5,
        flexShrink: 0,
        height: '100%',
    },

    plannerTitle: {
        alignSelf: 'start',
        margin: '4px 0 2px 0',
    },
    plannerTitleSingle: {
        alignSelf: 'start',
        margin: '0',
        fontSize: '10px',
    },

    plannerTime: {
        lineHeight: 1,
        alignSelf: 'start',
        fontSize: '10px',
    },

    dragOverlayItem: {
        // height: UNSCHEDULED_BLOCK_HEIGHT,
        cursor: 'grab', // 드래그 가능함을 표시
        borderRadius: theme.radius.sm,
        margin: '2px 0',
        overflow: 'hidden',
        fontSize: theme.fontSizes.xs,
        fontWeight: 400,
        borderStyle: 'solid',
        borderWidth: 2,
        transition: 'box-shadow 0.2s, opacity 0.2s',
        userSelect: 'none', // 드래그 중 텍스트 선택 방지

        '&:hover': {
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        },

        '&:active': {
            cursor: 'grabbing', // 드래그 중 커서 변경
        },
    },

    unscheduledPlannerContent: {
        display: 'flex',
        alignItems: 'center',
        padding: 0,
        width: '100%',
        height: '100%',
        borderRadius: theme.radius.sm,
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: 'transparent',
    },

    // unscheduled 더보기 버튼
    expandUnscheduledPlannerButton: {
        width: '100%',
        padding: '0 4px',
        borderRadius: theme.radius.sm,
        fontSize: theme.fontSizes.xs,
        fontWeight: 400,
        borderStyle: 'solid',
        borderWidth: 2,
        borderColor: 'transparent',

        '&:hover': {
            backgroundColor: theme.colors.gray[1],
        },
    },

    unscheduledColorBar: {
        width: 5,
        height: '100%',
        flexShrink: 0,
    },

    unscheduledTitle: {
        marginLeft: 8,
        lineHeight: 1.2,
    },

    dragGuide: {
        pointerEvents: 'none',
        zIndex: 999,
        transition: 'top 0.1s ease-out',
    },
}));
